import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { hideHeader } from "../../actions/appStatus.actions";

import { changeCurrentStep } from "../../actions/processStep.actions";
import { getWebsiteUrl } from "../../utils/content";

class PaymentUnavailableComponent extends Component {
  constructor(props) {
    super(props);
    this.props.changeCurrentStep(2);
  }

  componentDidMount() {
    // Hide the loan payment header
      this.props.hideHeader();
  }

  render() {
    // default to contact center so we dont show an empty page
    var reason = this.props.loans.PaymentNotAllowedReasonHtml || 'We couldn’t process this loan payment online today. Give our Contact Center a call at <a class="give-us-a-call" href="tel:+18882677200">888.267.7200</a> and let’s figure out what’s going on. Talk to you soon!';
    return (
      <div className="error-page">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="error-container">
                <h1>Well, That's A Bummer</h1>
                <p dangerouslySetInnerHTML={{ __html: reason }} />
                <a href={getWebsiteUrl()} className="button tertiary">
                  GO TO LAKETRUST.ORG
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Map global store to component props
const mapStateToProps = state => state;

// Hook up actions to component
const mapDispatchToProps = {
  changeCurrentStep,
  hideHeader
};

//Connect to Redux store
const PaymentUnavailable = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PaymentUnavailableComponent)
);

export default PaymentUnavailable;



// WEBPACK FOOTER //
// ./src/components/payment-unavailable/payment-unavailable.component.js